export default "__VITE_ASSET__e598bc38__"